import React from "react";
import { useTranslation } from "react-i18next";
import {
  StyledModalBody,
  StyledModal,
  StyledModalFooter,
  ModalLogoWrapper,
  ModalLogoABC,
  ModalLogoPUB,
  ModalLogoYET,
  ModalLogoFUN,
  ModalLogoCAC,
  ModalLogoHYC,
} from "../styledComponents/StyledModals";
import { StyledButton } from "../styledComponents/CommonStyledComponents";

export const ConfirmCancelBonusDialog = ({
  showModal,
  handleProceed,
  handleCancel,
  skin,
}) => {
  const { t } = useTranslation("");

  return (
    <StyledModal isOpen={showModal}>
      <ModalLogoWrapper>
        {skin === "abc" && <ModalLogoABC />}
        {skin === "pub" && <ModalLogoPUB />}
        {skin === "yet" && <ModalLogoYET />}
        {skin === "fun" && <ModalLogoFUN />}
        {skin === "cac" && <ModalLogoCAC />}
        {skin === "hyc" && <ModalLogoHYC />}
      </ModalLogoWrapper>
      <StyledModalBody position>
        {t("label_confirm_cancel_bonus")}
      </StyledModalBody>
      <StyledModalFooter>
        <StyledButton
          banktransfer
          pub={skin === "pub"}
          onClick={() => handleProceed()}
        >
          {t("label_proceed")}
        </StyledButton>
        <StyledButton
          dialog
          pub={skin === "pub"}
          onClick={() => handleCancel()}
        >
          {t("label_cancel")}
        </StyledButton>
      </StyledModalFooter>
    </StyledModal>
  );
};
